// extracted by mini-css-extract-plugin
export var languageMenu = "LanguageMenu-module--languageMenu--1c7jG";
export var heading = "LanguageMenu-module--heading--2uZjx";
export var languageList = "LanguageMenu-module--languageList--fglO6";